import css from './disclaimer.module.scss';
import Modal from 'src/components/common/modal/modal';
import { ReactComponent as Like } from 'src/assets/like.svg';
import { ReactComponent as Info } from 'src/assets/info-icon.svg';
import { ReactComponent as Pattern } from 'src/assets/uaf-pattern.svg';

export default function Disclaimer() {
  return (
    <Modal
      isOpen={window.sessionStorage?.getItem('HideDisclaimer') !== 'true'}
      onClose={() => window.sessionStorage?.setItem('HideDisclaimer', 'true')}
      closeOnDocumentClick={false}>
      {(close: () => void) => (
        <div className={css.disclaimerContainer}>
          <div className={css.leftPart}>
            <Info />
            <Pattern className={css.pattern} />
          </div>
          <div className={css.disclaimer}>
            <div className={css.warning}>
              <p>
                На зв&apos;язку є агрегатором інформації та не несе відповідальність за кінцевого надавача послуг. Якщо
                Ви помітили помилку, будь ласка повідомте про неї натиснувши на іконку “<strong>три крапки</strong>” в
                правому верхньому куті послуги.
              </p>
            </div>
            <button onClick={close}>
              <Like />
              Зрозуміло, дякую
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
}
